import React from 'react';
import PropTypes from 'prop-types';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import styled from 'src/ui/library/styled';

const styles = (theme, props) => ({
  root: {},
  panelRoot: {
    marginBottom: '16px',
    boxShadow: 'none',
    border: '1px solid #C4C4CE',
    '&:before': {
      backgroundColor: 'transparent',
    },
  },
  panelSummaryRoot: {
    height: '48px',
    '&$panelSummaryExpanded': {
      backgroundColor: theme.colors.eyGrey4,
      borderBottom: `solid 1px ${theme.colors.eyGrey6}`,
      boxShadow: '0 0 8px 0 rgba(0,0,0,0.08)',
    },
  },
  panelSummaryContent: {
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: '0px',
    '& > :last-child': {
      paddingRight: '0px',
    },
  },
  panelSummaryExpanded: {
    minHeight: 'auto !important',
  },
  panelDetails: {
    padding: '24px 24px 24px',
  },
  panelTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
  panelIcon: {
    fontSize: '20px',
    fontWeight: 'bold',
  },
  heading: {},
});

class AccordionBase extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override AccordionBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <Accordion> */
    className: PropTypes.string,
    /** Props to be applied to each section */
    sections: PropTypes.array.isRequired,
  };

  static defaultProps = {};

  state = {
    expanded: null,
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    const { children, classes, sections } = this.props;
    const { expanded } = this.state;

    return (
      <div className={classes.root}>
        {React.Children.map(children, (child, index) => {
          const panelProps = sections[index];
          return (
            <ExpansionPanel
              expanded={expanded === index}
              key={index}
              classes={{ root: classes.panelRoot }}
              onChange={this.handleChange(index)}>
              <ExpansionPanelSummary
                classes={{ root: classes.panelSummaryRoot, content: classes.panelSummaryContent, expanded: classes.panelSummaryExpanded }}>
                <div className={classes.panelTitle}>{panelProps.label ? panelProps.label : ''}</div>
                <div className={classes.panelIcon} dangerouslySetInnerHTML={{ __html: expanded === index ? '&#8722;' : '+' }} />
              </ExpansionPanelSummary>
              <ExpansionPanelDetails classes={{ root: classes.panelDetails }}>{child}</ExpansionPanelDetails>
            </ExpansionPanel>
          );
        })}
      </div>
    );
  }
}

export { AccordionBase };
export default styled(AccordionBase)(styles);



// WEBPACK FOOTER //
// ./src/ui/library/Accordion/AccordionBase.js